import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import ContentCard from 'components/ContentCard/ContentCard';
import { generateID } from 'utils/helpers';
import { checkProtocolWishListUrl } from 'utils/wishListDomain';

import wishListSwagStore from '../../../images/profilePage/wishListSwagStore.png';
import wishListAmazon from '../../../images/profilePage/wishListAmazon.png';
import wishListEden from '../../../images/profilePage/wishListEden.png';
import wishListStockroom from '../../../images/profilePage/wishListStockroom.png';

import styles from './WishListProfileV2.css';


const wishImagesMap = {
  wishListSwagStore,
  wishListAmazon,
  wishListEden,
  wishListStockroom,
};


const WishListProfileV2 = (props) => {
  const IDS = {
    prefix: 'lOpp2iM8',
    element: 'wishlist',
    wishListSwagStore: 'wishListSwagStore',
    wishListAmazon: 'wishListAmazon',
    wishListEden: 'wishListEden',
    wishListStockroom: 'wishListStockroom',
  };

  const makeId = generateID(IDS.prefix, IDS.element);

  return (
    <ContentCard
      className={styles.container}
      contentClass={styles.content}
      title={translate('account.wishList')}
    >
      {Object.keys(props.wishList).map((wish) => {
        if (!props.wishList[wish]) {
          return null;
        }

        return (
          <a
            key={wish}
            href={checkProtocolWishListUrl(props.wishList[wish])}
            id={makeId(wish)}
            rel="noopener noreferrer"
            target="_blank"
          >
            <div className={styles.wishListItem}>
              <img
                alt="wish list"
                className={styles.wishImage}
                src={wishImagesMap[wish] || ''}
              />
            </div>
          </a>
        );
      })}
    </ContentCard>
  );
};

WishListProfileV2.propTypes = { wishList: PropTypes.object.isRequired };

export default observer(WishListProfileV2);
